import _ from 'lodash';

const analyticsTypes = {
  SEARCH_PERFORM: 'search_Search',
  SEARCH_ADD_TO_CART_OPEN: 'search_AddToCart_Open',
  SEARCH_ADD_TO_CART_DISMISS: 'search_AddToCart_Dismiss',
  SEARCH_ADD_TO_CART_SUCCESS: 'search_AddToCart_Success',
  SEARCH_ADD_TO_CART_FAILURE: 'search_AddToCart_Failure',
  SEARCH_BANNER_OPEN: 'search_Banner_Open',
  SEARCH_BANNER_CLICK: 'search_Banner_Click',
  SEARCH_ITEM_DETAILS_OPEN: 'search_Item_Details_Open',
  SEARCH_ITEM_ORDERS_OPEN: 'search_Item_Orders_Open',
  SEARCH_ITEM_SIMILAR_OPEN: 'search_Item_Similar_Open',
  SEARCH_ITEM_LISTS_OPEN: 'search_Item_Lists_Open',
  SEARCH_ITEM_PROMOTIONS_OPEN: 'search_Item_Promotions_Open',
  SEARCH_ITEM_NOTES_OPEN: 'search_Item_Notes_Open',
  SEARCH_ITEM_REVIEWS_OPEN: 'search_Item_Reviews_Open',
  SEARCH_ITEM_DETAIL_VIEW: 'search_ItemDetails_View',
  SEARCH_HELP_REQUEST: 'search_HelpRequest',
  SEARCH_ITEM_TRACKERS_OPEN: 'search_Item_Trackers_Open',
  SEARCH_MESSAGE_CLICK: 'search_Item_Message_Click',
  SEARCH_ADD_CONNECT_OPEN: 'search_Add_Connect_Open',
};

const extractAddToCartValues = (supply, item, campaignItems, extra) => ({
  supply_id: _.get(supply, 'id'),
  item_id: _.get(item, 'id'),
  supplier_id: _.get(supply, 'supplier_id'),
  supplier_name: _.get(supply, 'supplier_name'),
  manufacturer_id: _.get(item, 'manufacturer_id'),
  // Segment Ecommerce fields
  // https://segment.com/docs/spec/ecommerce/v2/#core-ordering
  product_id: _.get(supply, 'id'),
  sku: _.get(supply, 'sku'),
  name: _.get(supply, 'name'),
  brand: _.get(item, 'manufacturer_name'),
  price: _.get(supply, 'price', 0) / 100,
  // End segment ecommerce fields
  list_price: _.get(supply, 'list_price', 0) / 100,
  effective_price: _.get(supply, 'effective_price', 0) / 100,
  total_price: (_.get(supply, 'price', 0) * _.get(extra, 'quantity', 1)) / 100,
  is_orderable: _.get(supply, 'is_orderable'),
  // Discounts
  has_campaign_items: !_.isEmpty(campaignItems),
  campaign_id: _.get(campaignItems, '0.campaign.id'),
  vendor_id: _.get(campaignItems, '0.campaign.vendor.id'),
  campaign_is_claimed: _.get(campaignItems, '0.is_claimed'),
  ...extra
});

const extractBannerValues = (banner) => {
  const trackingValues = {
    banner_name: _.get(banner, 'name'),
    banner_slug: _.get(banner, 'slug'),
  };
  // Add additional ids depending on the type of banner
  const searchBannerId = _.get(banner, 'search_banner_id');
  if (searchBannerId) {
    trackingValues.search_banner_id = searchBannerId;
  }
  const productSearchGroupId = _.get(banner, 'product_search_group_id');
  if (productSearchGroupId) {
    trackingValues.product_search_group_id = productSearchGroupId;
  }
  return trackingValues;
};

const extractItemValues = (item, extra) => ({
  item_id: _.get(item, 'id'),
  item_name: _.get(item, 'name'),
  manufacturer_id: _.get(item, 'manufacturer_id'),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.SEARCH_PERFORM
}, {
  type: analyticsTypes.SEARCH_ADD_TO_CART_OPEN,
  attributesExtractor: extractAddToCartValues
}, {
  type: analyticsTypes.SEARCH_ADD_TO_CART_DISMISS,
  attributesExtractor: extractAddToCartValues
}, {
  type: analyticsTypes.SEARCH_ADD_TO_CART_SUCCESS,
  attributesExtractor: extractAddToCartValues
}, {
  type: analyticsTypes.SEARCH_ADD_TO_CART_FAILURE,
  attributesExtractor: extractAddToCartValues
}, {
  type: analyticsTypes.SEARCH_BANNER_OPEN,
  attributesExtractor: extractBannerValues
}, {
  type: analyticsTypes.SEARCH_BANNER_CLICK,
  attributesExtractor: extractBannerValues
}, {
  type: analyticsTypes.SEARCH_ITEM_DETAILS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_ORDERS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_SIMILAR_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_LISTS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_PROMOTIONS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_NOTES_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_REVIEWS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ITEM_DETAIL_VIEW,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_HELP_REQUEST,
}, {
  type: analyticsTypes.SEARCH_ITEM_TRACKERS_OPEN,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_MESSAGE_CLICK,
  attributesExtractor: extractItemValues
}, {
  type: analyticsTypes.SEARCH_ADD_CONNECT_OPEN,
}];

export {
  analyticsTypes,
  analyticsActions
};
